export default "__VITE_ASSET__rpq27fks__"